import { render, staticRenderFns } from "./v-list.vue?vue&type=template&id=0e7ce5a4&scoped=true&"
import script from "./v-list.vue?vue&type=script&lang=js&"
export * from "./v-list.vue?vue&type=script&lang=js&"
import style0 from "./v-list.vue?vue&type=style&index=0&id=0e7ce5a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7ce5a4",
  null
  
)

export default component.exports